<app-segmented-tabs
  class="timeframe-selector"
  idPrefix="timeframe"
  variant="neutral"
  size="sm"
  [options]="segments"
  [value]="activeValue"
  (optionClick)="onOptionClick($event)"
></app-segmented-tabs>
